const ErrorCodes = {
  "UI-E-001": {
    code: "UI-E-001",
    title: "Something went wrong",
    message:
      "We’re having trouble loading the requested data. Please try again shortly.",
  },
  "SERVER-E-001": {
    code: "SERVER-E-001",
    title: "Server error",
    message:
      "We’re having trouble loading the requested data. Please try again shortly.",
  },
  "AUTH-E-001": {
    code: "AUTH-E-001",
    title: "Authentication Failed",
    message: "Authentication failed due to invalid credentials.",
    description:
      "The credentials provided are invalid. Please check your username and password and try again.",
  },
  "AUTH-E-002": {
    code: "AUTH-E-002",
    title: "Session Expired",
    message: "Session has expired. Please log in again.",
    description:
      "Your active session may have expired or we may be having difficulties finding your session information.",
  },
  "AUTH-E-003": {
    code: "AUTH-E-003",
    title: "Access Denied",
    message:
      "Access denied. You do not have permission to access this resource.",
    description:
      "You do not have permission to access this resource. Please contact your administrator for assistance.",
  },
  "AUTH-E-004": {
    code: "AUTH-E-004",
    title: "Resource Not Found",
    message: "Resource not found. Please check the URL and try again.",
    description:
      "The resource you are trying to access could not be found. Please check the URL and try again.",
  },
  "AUTH-E-005": {
    code: "AUTH-E-005",
    title: "Internal Server Error",
    message: "Internal server error. Please try again later.",
    description: "An internal server error occurred. Please try again later.",
  },
  "REQ-E-0001": {
    code: "API-E-0001",
    title: "INVALID_REQUEST",
    message: "We’re having trouble loading the requested data. Please try again shortly.",
  },
  "REQ-E-0002": {
    code: "API-E-0002",
    title: "VALIDATION_FAILED",
    message: "We’re having trouble loading the requested data. Please try again shortly.",
  },
  "REQ-E-0003": {
    code: "API-E-0003",
    title: "DUPLICATE_RESOURCE",
    message: "We’re having trouble loading the requested data. Please try again shortly.",
  },
  "REQ-E-0004": {
    code: "API-E-0004",
    title: "MISSING_REQUIRED_FIELD",
    message: "We’re having trouble loading the requested data. Please try again shortly.",
  },
  "REQ-E-0005": {
    code: "API-E-0005",
    title: "Bad request",
    message:
      "We’re having trouble loading the requested data. Please try again shortly.",
  },
  "M-E-0001": {
    code: "MKT-E-0001",
    title: "INACCESSIBLE_MARKET",
    message: "This market is not applicable for this module.",
  },
};

export default ErrorCodes;
